import { render, staticRenderFns } from "./ValidationAaf.vue?vue&type=template&id=7071312d&scoped=true&"
import script from "./ValidationAaf.vue?vue&type=script&lang=js&"
export * from "./ValidationAaf.vue?vue&type=script&lang=js&"
import style0 from "./ValidationAaf.vue?vue&type=style&index=0&id=7071312d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7071312d",
  null
  
)

export default component.exports